// extracted by css-extract-rspack-plugin
export default {"title":"SectionContainer-module__title","titleDesktop":"SectionContainer-module__titleDesktop","titleLine":"SectionContainer-module__titleLine"};